import { Store, createEvent } from 'effector'
import storagePromise from './storage'

import * as UserStore from '@store/user/user'
import * as AdminStore from '@store/admin/admin'
import * as AuthStore from '@store/auth/auth'
import * as SiteStore from '@store/site/site'
import * as IncidentStore from '@store/incident/incident'
import * as EDLStore from '@store/edl/edl'
import * as LocationStore from '@store/location/location'
import * as SocieteStore from '@store/societe/societe'
import * as FamilleStore from '@store/famille/famille'
import * as CommandeStore from '@store/commande/commande'
import * as PlanStore from '@store/plan/plan'
import * as UsersStore from '@store/users/users'
import * as FiltreStore from '@store/filtre/filtre'
import * as ControleStore from '@store/controle/controle'
import * as MetierStore from '@store/metier/metier'
import * as QuestionStore from '@store/question/question'
import * as ContactsStore from '@store/contacts/contacts'
import * as HelpStore from '@store/help/help'

const stores: Store<any>[] = [
  UserStore.store,
  SiteStore.store,
  IncidentStore.store,
  AuthStore.store,
  LocationStore.store,
  SocieteStore.store,
  FamilleStore.store,
  CommandeStore.store,
  PlanStore.store,
  EDLStore.store,
  AdminStore.store,
  UsersStore.store,
  FiltreStore.store,
  ControleStore.store,
  MetierStore.store,
  QuestionStore.store,
  ContactsStore.store,
  HelpStore.store,
]

export const persist = (): Promise<void> => {
  const VERSION = '11'
  const VERSION_KEY = 'persist:version'

  // encryptor is ready, we can use store
  return storagePromise.then((Storage) => {
    return Storage.getItem(VERSION_KEY).then((version) => {
      const VersionResolver =
        version === VERSION ? Promise.resolve(true) : Storage.setItem(VERSION_KEY, VERSION).then(() => false)

      return VersionResolver.then((reload) => {
        // inspiré de https://github.com/MrFranke/effector-persist/blob/master/src/index.ts
        const rehydrate = createEvent('REHYDRATE')

        const persistStore = <State>(store: Store<State>): Promise<void> => {
          const name = store.shortName
          const persistKey = `persist:${name}`

          const ReloadResolver = reload
            ? Storage.getItem(persistKey).then((snapshot) => {
                if (snapshot) {
                  store.on(rehydrate, () => JSON.parse(snapshot))
                  rehydrate()
                }
              })
            : Promise.resolve()

          return ReloadResolver.then(() => {
            store.watch((state) => {
              Storage.setItem(persistKey, JSON.stringify(state))
            })
          })
        }

        return Promise.all(stores.map(persistStore)).then()
      })
    })
  })
}

export const reset = () => {
  // put reset actions
  UserStore.actions.reset()
  SiteStore.actions.reset()
  AuthStore.actions.reset()
  IncidentStore.actions.reset()
  LocationStore.actions.reset()
  SocieteStore.actions.reset()
  FamilleStore.actions.reset()
  CommandeStore.actions.reset()
  PlanStore.actions.reset()
  EDLStore.actions.reset()
  AdminStore.actions.reset()
  UsersStore.actions.reset()
  FiltreStore.actions.reset()
  ControleStore.actions.reset()
  MetierStore.actions.reset()
  QuestionStore.actions.reset()
  ContactsStore.actions.reset()
}

export const onNewUser = () => {
  // reset every store except User and Auth
  SiteStore.actions.reset()
  IncidentStore.actions.reset()
  LocationStore.actions.reset()
  SocieteStore.actions.reset()
  FamilleStore.actions.reset()
  CommandeStore.actions.reset()
  PlanStore.actions.reset()
  EDLStore.actions.reset()
  AdminStore.actions.reset()
  UsersStore.actions.reset()
  FiltreStore.actions.reset()
  ControleStore.actions.reset()
  MetierStore.actions.reset()
  QuestionStore.actions.reset()
  ContactsStore.actions.reset()
  HelpStore.actions.reset()
}
